// What the Dashboard shows while its figures load, after they load, or when a
// read failed. SEQ-240: a failed read used to leave the hooks' starting values
// (zero) in place, so the cards printed $0 as if it were real. A failed read now
// shows a "could not load" state with no number, and nothing is sent to the AI
// insight, because the insight only exists inside the loaded dashboard.
export type DashboardLoadState = "loading" | "error" | "ready";

export function dashboardLoadState(input: {
  projectsLoading: boolean;
  statsLoading: boolean;
  variationsLoading: boolean;
  projectsError: boolean;
  statsError: boolean;
  variationsError: boolean;
}): DashboardLoadState {
  if (input.projectsLoading || input.statsLoading || input.variationsLoading) return "loading";
  if (input.projectsError || input.statsError || input.variationsError) return "error";
  return "ready";
}
